<template>
  <div class="external-directory-page text-center">
    <TopMenu
      :title="$t('CONTACT_US.PAGE_LABEL')"
      back-to="/dashboard"
      dark-background/>
    <div class="container-fluid content">
      <div class="row-item-transparent-with-border mt-3 pr-4 pl-4 text-left">
        <h3>{{ $t('SIDEMENU.DIRECTORY') }}</h3>
      </div>
      <div
        v-for="(office, index) in getOffices(externalDirectory)"
        :key="index"
        class="mt-3 pb-2 pr-4 pl-4 text-left border-bottom">
        <office-information
          :office="office"
          :is-already-expanded="false"
          :bold-name="true"
          expandable/>
      </div>
    </div>
    <BottomMenu />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import TopMenu from '@/components/Menu/TopMenu';
import BottomMenu from '@/components/Menu/BottomMenu';
import OfficeInformation from '@/components/Information/OfficeInformation';

export default {
  name: 'ExternalDirectory',
  components: {
    TopMenu,
    BottomMenu,
    OfficeInformation,
  },
  data() {
    return {
      openedIndex: null,
    };
  },
  computed: {
    ...mapState('contactUs', ['externalDirectory']),
    ...mapGetters('contactUs', ['getOffices']),
  },
  watch: {},
  created() {
    this.$store.dispatch('contactUs/getExternalDirectory');
  },
  methods: {
    isOpened(index) {
      return index === this.openedIndex;
    },
    expand(index) {
      if (this.isOpened(index)) this.openedIndex = null;
      else this.openedIndex = index;
    },
  },
};
</script>

<style scoped lang="scss">
div {
  &.external-directory-page {
    height: 100%;
  }
  &.content {
    padding-top: $top-menu-height;
    padding-bottom: $bottom-menu-height;
    background-color: $base;
    min-height: 100%;
  }
}
</style>
